import React from "react";
import Select from "react-select";
import { Modal } from "react-bootstrap";
import Context from "../../Context";
import Blocker from "../Misc/Blocker";
import SuperSelect from "../Misc/SuperSelect";
import DocumentPicker from "../Misc/DocumentPicker";

export default class EntityDialog extends React.Component {
  static contextType = Context;
  constructor(props) {
    super(props);
    this.editorState = this.props.editorState;
    this.entityKey = this.props.entityKey;
    this.contentState = this.editorState.getCurrentContent();
    this.entity = this.contentState.getEntity(this.props.entityKey);
    this.entityData = this.entity.getData();

    let entityData = {};
    for (let dataKey in this.entityData) {
      entityData[dataKey] = this.entityData[dataKey];
    }

    let documentAnchors = [];
    if (entityData.kind === "link") {
      const blockMap = this.contentState.getBlockMap().toJS();
      for (let blockKey in blockMap) {
        if (blockMap[blockKey].type.startsWith("header-")) {
          documentAnchors.push({
            value: blockKey,
            label: blockMap[blockKey].text,
          });
        }
      }
    }

    this.state = {
      entityData,
      documentAnchors,
    };
  }

  onHide = () => {
    this.props.onHide();
  };

  onChange = (e) => {
    let id = e.target.id;
    let value = id === "multiple" ? e.target.checked : e.target.value;

    let entityData = this.state.entityData;

    entityData[id] = value;
    this.setState({ entityData });
  };

  onVariantsChange = (list) => {
    let entityData = this.state.entityData;
    entityData.list = list;
    this.setState({ entityData });
  };

  onDocumentChange = (documentId) => {
    let entityData = this.state.entityData;
    entityData.linkDocument = documentId;
    this.setState({ entityData });
  };
  onSave = () => {
    let data = this.state.entityData;
    if (!data.code) {
      data.code = this.context.key();
    }
    this.props.onSave(this.entityKey, data);
  };

  render() {
    let kind = this.state.entityData.kind;
    let kinds = {
      text: "Текстовое поле",
      select: "Выпадающий список",
      check: "Галочки",
      image: "Изображение",
      link: "Ссылка",
    };
    return (
      <>
        <Modal show onHide={this.onHide}>
          <Modal.Header closeButton closeLabel="Закрыть">
            <Modal.Title>Элемент: {kinds[kind]}</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            {kind === "text" || kind === "select" || kind === "check" ? (
              <div className="row">
                <div className="col-lg-6">
                  <div className="form-group">
                    <label>Имя</label>
                    <input
                      type="text"
                      id="name"
                      className="form-control"
                      value={this.state.entityData.name || ""}
                      onChange={this.onChange}
                      onKeyPress={(e) => {
                        if (e.key === "Enter") this.onSave();
                      }}
                    />
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="form-group">
                    <label>Код</label>
                    <input
                      type="text"
                      id="code"
                      className="form-control"
                      value={this.state.entityData.code || ""}
                      onChange={this.onChange}
                      onKeyPress={(e) => {
                        if (e.key === "Enter") this.onSave();
                      }}
                    />
                  </div>
                </div>
              </div>
            ) : null}

            {kind === "link" ? (
              <div className="row">
                <div className="col-lg-12">
                  <div className="form-group">
                    <label>Тип ссылки</label>
                    <select
                      type="text"
                      id="linkType"
                      className="form-control"
                      value={this.state.entityData.linkType}
                      onChange={this.onChange}
                    >
                      <option value={"url"}>На URL</option>
                      <option value={"internal_document"}>
                        На внутренний документ
                      </option>
                      <option value={"header"}>
                        На заголовок в этом документе
                      </option>
                    </select>
                  </div>
                </div>
              </div>
            ) : null}

            {kind === "link" && this.state.entityData.linkType === "url" ? (
              <div className="row">
                <div className="col-lg-12">
                  <div className="form-group">
                    <label>URL</label>
                    <input
                      type="text"
                      id="linkURL"
                      className="form-control"
                      value={this.state.entityData.linkURL}
                      onChange={this.onChange}
                      onKeyPress={(e) => {
                        if (e.key === "Enter") this.onSave();
                      }}
                    />
                  </div>
                </div>
              </div>
            ) : null}

            {kind === "link" &&
            this.state.entityData.linkType === "internal_document" ? (
              <div className="row">
                <div className="col-lg-12">
                  <div className="form-group">
                    <label>Внутренний документ</label>
                    <EntityDialogDocuments
                      onChange={this.onDocumentChange}
                      value={this.state.entityData.linkDocument}
                    />
                  </div>
                </div>
              </div>
            ) : null}

            {kind === "link" && this.state.entityData.linkType === "header" ? (
              <div className="row">
                <div className="col-lg-12">
                  <div className="form-group">
                    <label>Заголовок в этом документе</label>
                    <Select
                      value={this.context.api.getReferenceValue(
                        this.state.entityData.linkAnchor,
                        this.state.documentAnchors
                      )}
                      onChange={(result) =>
                        this.onChange({
                          target: { id: "linkAnchor", value: result.value },
                        })
                      }
                      className="from-control react-select"
                      classNamePrefix="react-select-inner"
                      options={this.state.documentAnchors}
                      placeholder="Выберите заголовок..."
                      noOptionsMessage={({ inputValue }) =>
                        `Ничего не найдено по запросу ${inputValue}`
                      }
                    />
                  </div>
                </div>
              </div>
            ) : null}

            {kind === "image" ? (
              <div className="row">
                <div className="col-lg-12">
                  <div className="form-group">
                    <label>Обтекание текстом</label>
                    <select
                      type="text"
                      id="float"
                      className="form-control"
                      value={this.state.entityData.float}
                      onChange={this.onChange}
                    >
                      <option value={"none"}>По умолчанию</option>
                      <option value={"right"}>Справа</option>
                      <option value={"left"}>Слева</option>
                    </select>
                  </div>
                </div>
                {this.state.entityData.file.name ? (
                  <div className="col-lg-12">
                    <div className="table-responsive">
                      <table className="table">
                        <tr>
                          <td>Имя файла</td>
                          <td>{this.state.entityData.file.name}</td>
                        </tr>
                        <tr>
                          <td>Тип файла</td>
                          <td>{this.state.entityData.file.type}</td>
                        </tr>
                        <tr>
                          <td>Изменен</td>
                          <td>
                            {this.state.entityData.file.lastModifiedDate.toLocaleString()}
                          </td>
                        </tr>
                        <tr>
                          <td>Размер</td>
                          <td>
                            {Math.floor(this.state.entityData.file.size / 1024)}
                            Кб
                          </td>
                        </tr>
                      </table>
                    </div>
                  </div>
                ) : null}
              </div>
            ) : null}

            {kind === "check" || kind === "select" ? (
              <EntityDialogVariants
                multiple={this.state.entityData.multiple}
                list={this.state.entityData.list || []}
                onChange={this.onVariantsChange}
              />
            ) : null}
            {kind === "check" ? (
              <div className="mt-4">
                <label className="checkbox">
                  <input
                    type="checkbox"
                    id="multiple"
                    onChange={this.onChange}
                    checked={this.state.entityData.multiple}
                  />
                  <span className="mr-2"></span>
                  Разрешить выбор нескольких значений
                </label>
              </div>
            ) : null}
            {kind === "text" ? (
              <div className="mt-4">
                <label className="checkbox">
                  <input
                    type="checkbox"
                    id="multiline"
                    onChange={this.onChange}
                    checked={this.state.entityData.multiline}
                  />
                  <span className="mr-2"></span>
                  Многострочное поле
                </label>
              </div>
            ) : null}
          </Modal.Body>

          <Modal.Footer>
            <button title="Сохранить параметры поля" onClick={this.onSave} className="btn btn-primary">
              Сохранить
            </button>
            <button title="Закрыть без сохранения" onClick={this.onHide} className="btn btn-light">
              Отмена
            </button>
          </Modal.Footer>
        </Modal>
      </>
    );
  }
}

class EntityDialogVariants extends React.Component {
  static contextType = Context;
  constructor(props) {
    super(props);

    let list = props.list || [];
    let refs = [];
    list.forEach((item, index) => {
      refs[index] = React.createRef();
    });
    this.state = {
      list,
      refs,
    };
  }

  update = (list, setFocusTo = false) => {
    let refs = [];
    list.forEach((item, index) => {
      refs[index] = React.createRef();
    });
    this.setState({ list, refs }, () => {
      if (setFocusTo) {
        let ref = this.state.refs[setFocusTo];
        if (ref) {
          if (ref.current) ref.current.focus();
        }
      }
    });
    this.props.onChange(list);
  };

  changeItem = (index, value) => {
    let list = this.state.list;
    list[index].name = value;
    this.update(list);
  };

  addItem = () => {
    let list = this.state.list;
    list.push({ name: "", default: false });
    this.update(list, list.length - 1);
  };

  deleteItem = (index) => {
    let list = this.state.list;
    delete list[index];
    this.update(list);
  };

  toggleDefaultItem = (index) => {
    let list = this.state.list;
    if (this.props.multiple) {
      list[index].default = !list[index].default;
    } else {
      list.forEach((item, itemIndex) => {
        item.default = itemIndex === index ? true : false;
      });
    }
    this.setState({ list });
  };

  render() {
    return (
      <div>
        <div className="d-flex justify-content-between">
          <h5 className="text-muted">Варианты значений</h5>
          <button
            type="button"
            onClick={() => this.addItem()}
            title="Добавить значение"
            aria-label="Добавить значение"
            className="btn btn-icon p-0 border-0 bg-transparent mr-3 flaticon2-add-1 text-muted text-hover-primary"
          ></button>
        </div>
        <div className="table-responsive">
          <table className="table">
            <tbody>
              {this.state.list.map((listItem, index) => {
                const item = listItem || {};
                return (
                  <tr key={index + 100}>
                    <td width={30} className="align-middle">
                      <button
                        type="button"
                        title="Включен по умолчанию"
                        aria-label="Включен по умолчанию"
                        onClick={() => this.toggleDefaultItem(index)}
                        className={`btn btn-icon p-0 border-0 bg-transparent text-primary icon-lg fa ${
                          item.default ? "fa-check-square" : "fa-square-o"
                        }`}
                      ></button>
                    </td>
                    <td className="align-middle">
                      <input
                        id={`list-var-input-${index}`}
                        ref={this.state.refs[index]}
                        type="text"
                        value={item.name}
                        onChange={(e) => this.changeItem(index, e.target.value)}
                        className="form-control"
                        onKeyPress={(e) => {
                          if (e.key === "Enter") this.addItem();
                        }}
                      />
                    </td>
                    <td width={30} className="align-middle text-right">
                      <button
                        type="button"
                        onClick={() => this.deleteItem(index)}
                        title="Удалить значение"
                        aria-label="Удалить значение"
                        className="btn btn-icon p-0 border-0 bg-transparent icon-sm flaticon2-cross text-muted text-hover-danger"
                      ></button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    );
  }
}

class EntityDialogDocuments extends React.Component {
  static contextType = Context;
  constructor(props) {
    super(props);
    this.state = {
      pending: false,
      documents: [],
      value: null,
    };
  }
  componentDidMount() {
    this.load();
  }
  load = async () => {
    this.setState({ pending: true });
    let documents = [];
    this.setState({ pending: false, documents, value: this.props.value });
  };
  onChange = (value) => {
    this.setState({ value });
    this.props.onChange(value);
  };
  render() {
    return (
      <Blocker on={this.state.pending}>
        <DocumentPicker
          classes={["instruction", "template"]}
          defaultValue={this.state.value}
          onChange={(value) => this.onChange(value)}
        />
      </Blocker>
    );
  }
}
